export default "__VITE_ASSET__K5R_wTOf__"